import type { GoogleAddress, UserAddress, UserAddressNew } from '../entities'
import type { UserAddressFieldNormalizedForBackend } from './types'
import { createGlovoError } from '@/tools/error-handling'

export function createNewUserAddressFromGoogleAddress(
  googleAddress: GoogleAddress
): UserAddressNew {
  const {
    placeId,
    longitude,
    latitude,
    title,
    countryCode,
    cityCode,
    addressComponents: { locality },
  } = googleAddress

  if (!placeId || !countryCode || !cityCode || !longitude || !latitude) {
    const err = createGlovoError('Invalid Google address: missing critical data', {
      placeId,
      longitude: longitude || '__UNKNOWN__',
      latitude: latitude || '__UNKNOWN__',
      title,
      countryCode: countryCode || '__UNKNOWN__',
      cityCode: cityCode || '__UNKNOWN__',
      locality: locality || '__UNKNOWN__',
    })
    throw err
  }

  const userAddress: UserAddressNew = {
    latitude: latitude,
    longitude: longitude,
    addressLine: title,
    countryCode: countryCode,
    cityCode: cityCode,
    cityName: locality || '',
    kind: 'APARTMENT',
    details: '',
    tag: null,
    fields: [],
  }

  return userAddress
}

export function normalizedAddressFieldsForBackend(
  fields: UserAddress['fields']
): UserAddressFieldNormalizedForBackend[] {
  return fields.map((f) => ({ id: f.type, value: f.value }))
}
